module.exports = __webpack_public_path__ + "img/zoosk.86f0fcf.svg";